import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { NEWS_DIALOG_SIZES, NEWS_SECTION } from "./types/enums";

export const opacityTransition = "opacity 0.5s ease-in-out";

const calculateSelectableImageWidth = (
  toSm?: boolean,
  toMd?: boolean,
  toLg?: boolean
) => {
  const IMAGE_WIDTH_TO_SM = "100%";
  const IMAGE_WIDTH_TO_MD = "48%";
  const IMAGE_WIDTH_TO_LG = "31%";
  const IMAGE_WIDTH_FROM_LG = "32%";

  if (toSm) {
    return IMAGE_WIDTH_TO_SM;
  }

  if (toMd) {
    return IMAGE_WIDTH_TO_MD;
  }

  if (toLg) {
    return IMAGE_WIDTH_TO_LG;
  }

  return IMAGE_WIDTH_FROM_LG;
};

interface StyleProps {
  listItem?: boolean;
  toMd?: boolean;
  toSm?: boolean;
  toLg?: boolean;
}

export const useStyles = ({
  listItem,
  toMd,
  toSm,
  toLg
}: StyleProps = {}): Record<string, CSSObject> => ({
  newsContentBox: {
    display: "flex",
    overflowX: "scroll",
    msOverflowStyle: "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */
  },
  emptyNews: {
    height: "92px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  newsCard: {
    borderRadius: "6px",
    padding: "16px",
    marginBottom: "16px",
    border: `1px solid ${colors.gray100}`,

    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.gray50,
      transition: "background-color 0.3s ease-in-out"
    }
  },
  newsImageBox: {
    height: listItem
      ? NEWS_SECTION.listImageHeight
      : NEWS_DIALOG_SIZES.dialogContentLoaderHeight,
    paddingBottom: listItem ? "unset" : "24px",
    width: "100%",
    display: "flex"
  },
  textBox: {
    maxWidth: "100%",
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  newsDialogTextContent: {
    height: toMd
      ? NEWS_DIALOG_SIZES.dialogTextContentLoaderHeightToMd
      : "107px",
    paddingBottom: "16px",
    'li[data-list="bullet"]': { listStyleType: "disc" }
  },
  rightArrowButton: {
    padding: "4px 4px 4px 20px",
    marginLeft: "-44px",
    right: "-2px",
    background:
      "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)",

    "&.Mui-focusVisible, &:hover, &:active, &:focus": {
      background:
        "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
    }
  },
  leftArrowButton: {
    padding: "4px 20px 4px 0",
    marginRight: "-44px",
    left: "-2px",
    background:
      "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)",

    "&.Mui-focusVisible, &:hover, &:active, &:focus": {
      background:
        "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
    }
  },
  repeatedArrowButtonStyles: {
    width: "56px",
    height: "179px",
    justifyContent: "center",
    alignItems: "center",
    position: "sticky",
    top: "73px",
    zIndex: 30
  },

  imageDropzone: {
    padding: "16px",
    borderRadius: "8px",
    display: "flex",
    border: `1px solid ${colors.gray300}`,
    alignItems: "center",
    justifyContent: "space-between"
  },
  noImageWarning: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  selectableImageDiv: {
    width: calculateSelectableImageWidth(toSm, toMd, toLg),
    cursor: "pointer"
  },
  selectImageContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: toSm ? "center" : "flex-start",
    gap: "16px",
    width: "100%",
    scrollbarGutter: "stable both-edges"
  },

  textColumn: {
    maxWidth: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },

  draftRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: "8px"
  }
});
